import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import * as SwitchPrimitives from '@radix-ui/react-switch';
import { cn } from 'cn';
const Switch = t0 => {
  const $ = _c(9);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("bg-tertiary-300 h-5", "peer inline-flex w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors", "focus-visible:ring-ring focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden", "disabled:cursor-not-allowed disabled:opacity-50", "data-[state=checked]:bg-primary", "data-[state=unchecked]:bg-input", "transition-all", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SwitchPrimitives.Thumb className={cn("pointer-events-none block size-4 rounded-full bg-white shadow-sm ring-0 transition-transform", "border-tertiary-300 border", "data-[state=checked]:translate-x-4", "data-[state=unchecked]:translate-x-0")} data-sentry-element="SwitchPrimitives.Thumb" data-sentry-source-file="switch.tsx" />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== t1) {
    t3 = <SwitchPrimitives.Root className={t1} {...props} data-sentry-element="SwitchPrimitives.Root" data-sentry-component="Switch" data-sentry-source-file="switch.tsx">{t2}</SwitchPrimitives.Root>;
    $[6] = props;
    $[7] = t1;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
Switch.displayName = SwitchPrimitives.Root.displayName;
export { Switch };